import { Component } from 'react'
import PropTypes from 'prop-types'
import SpinnerButton from '@components/forms/spinner_button.tsx'
import SpamHamApi from '@api/spam_ham_web_api.js'
import ErrorTypes from '@constants/error_types.js'
import Status from '@constants/request_statuses.ts'

export default class SpamHamSubmitter extends Component {
  static propTypes = {
    spammableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spammableType: PropTypes.string.isRequired,
    spamOrHam: PropTypes.oneOf(['spam', 'ham']).isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    training: PropTypes.bool,
  }

  static defaultProps = {
    training: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      submitStatus: Status.IDLE,
      message: null,
    }
  }

  handleSubmit = e => {
    this.submitHamSpam()
  }

  setSubmitStatus(submitStatus) {
    this.setState({ submitStatus })
  }

  setMessage(message) {
    this.setState({ message })
  }

  submitHamSpam() {
    const { spammableId, spammableType, spamOrHam, training } = this.props
    this.setSubmitStatus(Status.LOADING)
    SpamHamApi.create(spammableId, spammableType, spamOrHam, training).then(
      res => {
        this.setSubmitStatus(Status.SUCCEEDED)
        this.setMessage(res.data.message)
      },
      err => {
        if (err.message === ErrorTypes.CALL_ALREADY_IN_PROGRESS) {
          return
        }
        this.setSubmitStatus(Status.FAILED)
        this.setMessage('Error')
      }
    )
  }

  getButtonContent() {
    const { className, label } = this.props
    const { submitStatus } = this.state
    const clickHandler = submitStatus === Status.IDLE ? this.handleSubmit : null
    const disabled = submitStatus === Status.LOADING
    return (
      <SpinnerButton onClick={clickHandler} disabled={disabled} className={className}>
        {label}
      </SpinnerButton>
    )
  }

  render() {
    const { submitStatus, message } = this.state
    switch (submitStatus) {
      case Status.IDLE:
      case Status.LOADING:
        return this.getButtonContent()

      case Status.SUCCEEDED:
      case Status.FAILED:
        return <span>{message}</span>
    }
  }
}
